"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { shouldSkipExceptionUpdate } from "./stale_response_handler";
export function mergeInvoiceState(currentState, response, updateRequestedAt) {
  const skipExceptions = shouldSkipExceptionUpdate(
    updateRequestedAt,
    currentState.lastDocumentSaveTime
  );
  const updatedInvoice = __spreadValues(__spreadValues({}, currentState.factorInvoice || {}), response.factor_invoice);
  if (skipExceptions && currentState.factorInvoice) {
    updatedInvoice.rules_failed = currentState.factorInvoice.rules_failed;
    updatedInvoice.failure_messages = currentState.factorInvoice.failure_messages;
  }
  return {
    factorInvoice: updatedInvoice
  };
}
